"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2022 BLUECROSS BLUESHIELD OF SOUTH CAROLINA ALL RIGHTS RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureContentService = void 0;
/**
 * @description: Utility for pulling in feature content
 */
const commweb_service_1 = require("./commweb-service");
const enums_1 = require("../enums");
class FeatureContentService {
    /**
     * Constructor
     *
     * This will configure and setup the Content Service
     *
     * @param apiConfig
     * @param commWebAuthenticationUrl
     */
    constructor(apiConfig, commServicesAuthConfig) {
        this.apiConfig = apiConfig;
        this.commWebService = new commweb_service_1.CommWebService(apiConfig);
        this.commServicesAuthConfig = commServicesAuthConfig;
    }
    /**
     * This will get all the content for a feature.
     * The constituent to construct the URL is retrieved from the <code>ApiConfig</code>
     *
     * @param feature {string} - the feature for which to get the content - example priorauth, claimstatus
     * @param branding {string} - the brand for which to get the content - example sc, bc
     */
    getContentByFeature(feature, branding) {
        const apiRequest = {
            method: enums_1.HttpMethod.GET,
            url: this.apiConfig.commServicesUrls.contentUrl + '/feature/' + this.apiConfig.constituent
                + '/' + branding + '/' + feature,
            customHeaders: { Authorization: 'Bearer ' + this.commServicesAuthConfig.authToken }
        };
        return new Promise((resolve, reject) => {
            let contentItems = new Map();
            this.commWebService.sendRequest(apiRequest).then((response) => {
                contentItems = this.processContentItems(response);
                resolve(contentItems);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
     * process array of content items to a map so that it'll be easier to process
     *
     * coming soon - handle any business sector code overrides
     *
     * @param response the raw content from the service
     * @returns content in a map
     */
    processContentItems(response) {
        const itemsMap = new Map();
        if (response && response.data && response.data.contentItems) {
            const contentItems = response.data.contentItems;
            for (const item of contentItems) {
                if (!itemsMap.has(item.id)) {
                    const newItem = {
                        id: item.id,
                        content: item.content,
                        format: item.format,
                        path: item.path,
                        created_date: item.created_date,
                        updated_date: item.updated_date
                    };
                    itemsMap.set(item.id, newItem);
                }
                else {
                    // handle BSC content here when implemented
                }
            }
        }
        return itemsMap;
    }
}
exports.FeatureContentService = FeatureContentService;
//# sourceMappingURL=feature-content-service.js.map